import styled from '@emotion/styled'
import { fonts, fontSizes } from 'src/utils/styles'

/* Styles for FilterTag */
export const StFilterTag = styled.button`
  all: unset;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: ${fonts.regular};
  font-size: ${fontSizes.subHeadlineDefault};
  background-color: ${props => (props.saleTag ? '#F082624D' : '#3331311a')};
  border-radius: 4px;
  padding: 0 0.75em 0.25em 0.75em;
  margin-right: 1em;
  margin-bottom: 0.5em;
`

export const StLabel = styled.span`
  margin-right: 0.5em;
`

export const StCloseIcon = styled.div`
  margin-top: -0.2em;
`

/* Styles for FilterTagList */
export const StFilterTagList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: ${props => (props.inGrid ? '-1.25em' : '-0.25em')};
  margin-bottom: 0.5em;
`

export const StClearAllButton = styled.div`
  all: unset;
  cursor: pointer;
  text-decoration: underline;
  font-family: ${fonts.regular};
  font-size: ${fontSizes.filterContainerMobile};
  margin-right: 1em;
  margin-bottom: 0.5em;
`
